<template>
  <Category
    cate-name="money"
    category-name="MONEY VOICE賞"
    category-intro="専門家と個人投資家の本音でつくる金融情報メディア「MONEY VOICE」で2020年にご紹介した記事の中から、特に注目を集めたものをセレクトしました。"
  />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
